import { Button } from 'react-bootstrap';
import React from 'react';
import './DisplayCourses.css'
import { Link } from 'react-router-dom';

const DisplayCourses = () => {
    const displayCourses = [
        {
            "id": 1,
            "name": "Computer Security Analyst",
            "pace": "full time",
            "duration": "6 months",
            "Language": "English",
            "Fees": 10000,
            "Time": "10:00 AM - 12:00 PM",
            "Weekly": "3 days",
            "img": "https://i.ibb.co/99QvqrM/download.jpg"
        },
        {
            "id": 2,
            "name": "Learn Ethical Hacking from Scratch",
            "pace": "part time",
            "duration": "3 months",
            "Language": "English",
            "Fees": 12000,
            "Time": "03:00 AM - 04:00 PM",
            "Weekly": "3 days",
            "img": "https://i.ibb.co/BnjG59H/002.jpg"
        },
        {
            "id": 3,
            "name": "Advanced Cyber Security Training Course",
            "pace": "part time",
            "duration": "2 months",
            "Language": "English",
            "Fees": 8000,
            "Time": "01:00 PM - 02:30 PM",
            "Weekly": "4 days",
            "img": "https://i.ibb.co/wcc0hJt/003.jpg"
        },
        {
            "id": 4,
            "name": "Internet of Things: Business Implications and Opportunities Online Short Course",
            "pace": "part time",
            "duration": "6 weeks",
            "Language": "English",
            "Fees": 6000,
            "Time": "10:00 AM - 12:00 PM",
            "Weekly": "3 days",
            "img": "https://i.ibb.co/Chg7d5v/004.jpg"
        },
    ]
    return (
        <>
            <h1 className='text-success'>Our Courses</h1>
            <div className='display-courses course-btn'>


                {
                    displayCourses.map(displayCourse =>
                        <div className='rounded border border-info p-3 mb-5'>
                            <img src={displayCourse.img} alt="" />
                            <h4 className='text-center'>{displayCourse.name}</h4>
                            <h5 className='text-center'>Tuition Fees:{displayCourse.Fees}</h5>
                            <p className='text-center'>Duration: {displayCourse.duration}</p>
                        </div>
                    )
                }
                <Link to='/courses'> <Button className='m-3 mt-0 mb-5' variant="primary">More Courses</Button></Link>
            </div>
        </>
    );
};

export default DisplayCourses;